export { default } from '../shared/lib/head'
export * from '../shared/lib/head'
